import { LenderName } from '@nemuru-eng/js-api-client';

import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { LenderIconAvatar } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';
import { StyledTooltip } from '@/components/shared/components/StyledTooltip';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

interface LenderAvatarsProps {
  lenderNames: LenderName[];
}

const MAX_VISIBLE = 4;

export const LenderAvatars = ({ lenderNames }: LenderAvatarsProps) => {
  const { getTextIdTranslation } = useTranslation();
  const hidden = lenderNames.slice(MAX_VISIBLE);

  return (
    <FlexRow justifyContent="flex-start" gridGap={8} minHeight="16px">
      {lenderNames.length > 0 ? (
        lenderNames.slice(0, MAX_VISIBLE).map((lenderName) => (
          <StyledTooltip key={lenderName} title={<Text tId={lenderName} />}>
            <span>
              <LenderIconAvatar size="small" transparent lenderName={lenderName} />
            </span>
          </StyledTooltip>
        ))
      ) : (
        <Font variant="caption" color="textSecondary">
          <Text tId={'CONFIGURATION_ERROR'} />
        </Font>
      )}
      {hidden.length > 0 && (
        <StyledTooltip title={hidden.map((lenderName) => getTextIdTranslation(lenderName)).join(', ')}>
          <span>
            <Font variant="body2" color="textSecondary">{`+${hidden.length}`}</Font>
          </span>
        </StyledTooltip>
      )}
    </FlexRow>
  );
};
